export default "__VITE_ASSET__Bu19Ztid__"